<div class="card-wrapper" [ngClass]="{'has-banner': hasCardBanner}">
  <div *ngIf='isPromoCard'>
    <div class="card-bg" *ngIf="bgImageSrc" [ngStyle]="{'background-image': 'url('+bgImageSrc+')'}"></div>
    <bw-icon-legacy *ngIf="closeable" iconName="close" size="24" (click)="handleCloseCard($event)"></bw-icon-legacy>
    <typography-legacy text-small-regular class="brand mb-sm">
      {{title}}
    </typography-legacy>
    <div class="card-body mb-sm">
      <p headline-semibold [ngStyle]="{'color': cardTextColor}">
        <ng-container *ngTemplateOutlet="cardBody"></ng-container>
      </p>
    </div>
    <div class="card-footer">
      <ng-content select="bw-card-footer-legacy"></ng-content>
    </div>
  </div>

  <div *ngIf='isActionCard' (click)="handleCardAction($event)">
    <bw-icon-legacy iconName="chevron_right" size="24" [color]="invertedColor ? 'var(--white)' : 'var(--gray-50)' "></bw-icon-legacy>
    <typography-legacy text-small-regular class="mb-sm" [ngStyle]="{'color': invertedColor ? 'var(--white)' : 'var(--brand)'}">
      {{title}}
    </typography-legacy>
    <div class="card-body">
      <typography-legacy text-large-semibold>
        <ng-container *ngTemplateOutlet="cardBody"></ng-container>
      </typography-legacy>
    </div>
  </div>

  <div *ngIf='isInfoCard' (click)="handleCardAction($event)">
    <typography-legacy headline-semibold class="mb-xs">
      {{title}}
    </typography-legacy>
    <typography-legacy text-small-regular class="mb-sm">
      {{subtitle}}
    </typography-legacy>
    <div class="card-body">
      <typography-legacy text-large-semibold>
        <ng-container *ngTemplateOutlet="cardBody"></ng-container>
      </typography-legacy>
    </div>
  </div>

  <div *ngIf='isActiveProductCard' (click)="handleCardAction($event)">
    <div class="flex-row space-between">
      <typography-legacy headline-semibold>
        {{title}}
      </typography-legacy>
      <bw-icon-legacy iconName="chevron_right" size="24" [color]="invertedColor ? 'var(--white)' : 'var(--gray-50)' "></bw-icon-legacy>
    </div>
    <typography-legacy text-small-regular class="mb-sm">
      {{subtitle}}
    </typography-legacy>
    <div class="card-header" class="mb-sm">
      <ng-content select="bw-card-header-legacy"></ng-content>
    </div>
    <div class="card-body">
      <typography-legacy text-large-semibold>
        <ng-container *ngTemplateOutlet="cardBody"></ng-container>
      </typography-legacy>
    </div>
  </div>

  <div *ngIf='isBasicCard' (click)="handleCardAction($event)">
    <div class="card-body">
      <typography-legacy>
        <ng-container *ngTemplateOutlet="cardBody"></ng-container>
      </typography-legacy>
    </div>
  </div>

</div>
<ng-content select="bw-card-banner-legacy"></ng-content>

<ng-template #cardBody>
  <ng-content select="bw-card-body-legacy"></ng-content>
</ng-template>
